import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Icon } from '../Icon';

const CompactStarRating = props => {
  const wrapperClasses = classNames(
    'compact-star-rating',
    'subheading--small',
    props.className
  );

  const formattedRating = Number(props.rating).toFixed(1);

  return (
    <div className={wrapperClasses}>
      <Icon className="compact-star-rating__star" name="star-full-green" />
      <span className="compact-star-rating__count">{formattedRating}</span>
    </div>
  );
};

CompactStarRating.propTypes = {
  className: PropTypes.string,
  rating: PropTypes.number.isRequired,
};

export default CompactStarRating;
